<template>
  <div>
    <Multiselect
      v-model="selectedCat"
      :options="options"
      placeholder="GAME TYPE"
      class="gameCat"
    ></Multiselect>
    </div>
</template>



<style lang="scss" scoped>
div{
  width:160px;
}
.gameCat {
  font-family: Play-Bold;
  color:$white;
  margin: 0px 20px 0px 0px;
  --ms-font-size: 14px;
  --ms-radius: 30px;
  --ms-border-color:$white;
  --ms-bg: linear-gradient(#FF6538, #A83D1D);
  --ms-dropdown-bg: rgb(245, 197, 182);
  --ms-placeholder-color: #ffffff;
}
</style>

<script>
import Multiselect from '@vueform/multiselect';
export default {
  components: {
      Multiselect,
    },
    data(){
        return {
            selectedCat:null,
            options:[
              'ALL',
              'F2P',
              'PREMIUM'
            ]
        }
    },
    watch: {
        selectedCat : function(){
            if (this.selectedCat === null) {this.selectedCat='ALL'}
            this.$store.commit("setGameCategory",{category:this.selectedCat});
        }
    },
    mounted(){
      this.selectedCat=this.$store.getters.getGameCat;
    }

}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>